import { FunctionComponent, useState } from "react";
import classes from './AddressFilter.module.scss';
import { CgClose } from 'react-icons/cg'

interface AddressFilterProps {
    filterAddresses: string[],
    setFilterAddresses: (addresses: string[]) => void
}

const AddressFilter: FunctionComponent<AddressFilterProps> = ({ filterAddresses, setFilterAddresses }) => {

    const [inputValue, setInputValue] = useState<string>('');

    const enterKeypressHandler = (e: any) => {
        if (e.key === "Enter") {
            setFilterAddresses([...filterAddresses, inputValue])
            setInputValue('');
        }
    }

    const handleSingleItemDelete = (index: number) => {
        setFilterAddresses([...filterAddresses.slice(0, index), ...filterAddresses.slice(index+1)])
    }

    return (<div className={classes.AddressFilter}>
        <input
            placeholder="Type the Address and press Enter"
            type="text"
            onKeyDown={enterKeypressHandler}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
        />
        <div className={classes.enteredAddresses}>
            {filterAddresses.map((e: string, index: number) =>
                <div className={classes.enteredAddress}>
                    {e}
                    <CgClose
                        className={classes.icon}
                        onClick={() => handleSingleItemDelete(index)}
                    />
                </div>
            )}
        </div>
    </div>);
}

export default AddressFilter;